module.exports = __webpack_public_path__ + "img/setting.30e14828.svg";